import { createShallowStore, createStore } from '@frontend/store';
import { ExtendedAppointment } from '../types';

type AppointmentEventCardStoreType = {
  isIntegratedOffice: boolean;
  appointmentDetails: ExtendedAppointment | null;
  setIsIntegratedOffice: (isIntegratedOffice: boolean) => void;
  setAppointmentDetails: (appointmentDetails: ExtendedAppointment | null) => void;
  closeAppointmentDetailsModal?: () => void;
  setCloseAppointmentDetailsModal: (closeAppointmentDetailsModal: () => void) => void;
};

const useAppointmentEventCardStore = createStore<AppointmentEventCardStoreType>(
  (set) => ({
    isIntegratedOffice: false,
    appointmentDetails: null,
    setIsIntegratedOffice: (isIntegratedOffice) => set({ isIntegratedOffice }),
    setAppointmentDetails: (appointmentDetails) => set({ appointmentDetails }),
    setCloseAppointmentDetailsModal: (closeAppointmentDetailsModal) => set({ closeAppointmentDetailsModal }),
  }),
  {
    name: 'AppointmentEventCardStore',
  }
);

export const useAppointmentEventCardShallowStore =
  createShallowStore<AppointmentEventCardStoreType>(useAppointmentEventCardStore);
